export default "__VITE_ASSET__Cs_H1XAH__"